module.exports = __webpack_public_path__ + "static/media/shortClosed.858d813d.svg";